<!-- =========================================================================================
  File Name: Dashboard.vue
  Description: Dashboard Analytics
========================================================================================== -->

<template>
  <div id="dashboard-analytics">
    <div class="vx-row">

      <!-- 程序介绍 -->
      <div class="vx-col w-full lg:w-1/2 mb-base">
        <vx-card slot="no-body" class="text-center bg-primary-gradient greet-user">
          <img src="@/assets/images/elements/decore-left.png" class="decore-left" alt="Decore Left" width="200" >
          <img src="@/assets/images/elements/decore-right.png" class="decore-right" alt="Decore Right" width="175">
          <feather-icon icon="AwardIcon" class="p-6 mb-8 bg-primary inline-flex rounded-full text-white shadow" svgClasses="h-8 w-8"></feather-icon>
          <h1 class="mb-6 text-white">尊敬的管理员，您好</h1>
          <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-white">
            欢迎您使用LAFEI - V程序。
          </p>
        </vx-card>
      </div>

      <!-- 会员数量 -->
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <statistics-card-line v-if="analyticsData.userCountTotalList.loaded" icon="UsersIcon" :statistic="analyticsData.userCountTotal" statisticTitle="会员总人数" :chartData="analyticsData.userCountTotalList" type='area'></statistics-card-line>
      </div>

      <!-- 彩票下注额 -->
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <statistics-card-line v-if="analyticsData.lotteryBetAmountList.loaded" icon="LifeBuoyIcon" :statistic="analyticsData.lotteryBetAmountTotal" statisticTitle="彩票下注额" :chartData="analyticsData.lotteryBetAmountList" color='warning' type='area'></statistics-card-line>
      </div>
    </div>

    <div class="vx-row">

      <!-- 充值 -->
      <div class="vx-col w-full md:w-1/2 mb-base">
        <vx-card>
          <div class="vx-row flex-col-reverse lg:flex-row">
            <div class="vx-col w-full lg:w-1/2 xl:w-1/2 flex flex-col justify-between">
              <div>
                <h2 class="mb-1 font-bold">¥ {{analyticsData.rechargeAmountTotal}}</h2>
                <span class="font-medium">充值总额</span>
                <p class="mt-2 text-xl font-medium">本周充值额增长了 <span class='text-success'>+{{analyticsData.rechargeAmountInc}}%</span></p>
              </div>
              <vs-button color="success" icon-pack="feather" icon="icon-chevrons-right" icon-after class="shadow-md w-full lg:mt-0 mt-4">
                <router-link :to="{ name: 'recordRecharge' }" class="text-white">
                  处理充值请求
                </router-link>
              </vs-button>
            </div>
            <div class="vx-col w-full lg:w-1/2 xl:w-1/2 flex flex-col lg:mb-0 mb-base">
              <small class="cursor-pointer text-right">近七日充值额变化</small>
              <vue-apex-charts v-if="analyticsData.rechargeAmountList.loaded" type=bar height=200 :options="analyticsData.rechargeAmountList.chartOptions" :series="analyticsData.rechargeAmountList.series" />
            </div>
          </div>
        </vx-card>
      </div>

      <!-- 提现 -->
      <div class="vx-col w-full md:w-1/2 mb-base">
        <vx-card>
          <div class="vx-row flex-col-reverse lg:flex-row">
            <div class="vx-col w-full lg:w-1/2 xl:w-1/2 flex flex-col justify-between">
              <div>
                <h2 class="mb-1 font-bold">¥ {{analyticsData.cashAmountTotal}}</h2>
                <span class="font-medium">提现总额</span>
                <p class="mt-2 text-xl font-medium">本周提现额增长了 <span class='text-success'>+{{analyticsData.cashAmountInc}}%</span></p>
              </div>
              <vs-button color="warning" icon-pack="feather" icon="icon-chevrons-right" icon-after class="shadow-md w-full lg:mt-0 mt-4">
                <router-link :to="{ name: 'recordCash' }" class="text-white">
                  处理提现请求
                </router-link>
              </vs-button>
            </div>
            <div class="vx-col w-full lg:w-1/2 xl:w-1/2 flex flex-col lg:mb-0 mb-base">
              <small class="cursor-pointer text-right">近七日提现额变化</small>
              <vue-apex-charts v-if="analyticsData.cashAmountList.loaded" color="warning" type=bar height=200 :options="analyticsData.cashAmountList.chartOptions" :series="analyticsData.cashAmountList.series" />
            </div>
          </div>
        </vx-card>
      </div>
    </div>

    <!-- 四格 -->
    <div class="vx-row">
      <div class="vx-col w-full md:w-1/4 mb-base">
        <vx-card title="今日充值">
          <span class="font-medium">¥ {{analyticsData.rechargeAmountToday || 0}}</span>
        </vx-card>
      </div>
      <div class="vx-col w-full md:w-1/4 mb-base">
        <vx-card title="今日提现">
          <span class="font-medium">¥ {{analyticsData.cashAmountToday || 0}}</span>
        </vx-card>
      </div>
      <div class="vx-col w-full md:w-1/4 mb-base">
        <vx-card title="今日下注">
          <span class="font-medium">¥ {{analyticsData.betAmountToday || 0}}</span>
        </vx-card>
      </div>
      <div class="vx-col w-full md:w-1/4 mb-base">
        <vx-card title="今日活跃人数">
          <span class="font-medium">{{analyticsData.userActiveToday || 0}}人</span>
        </vx-card>
      </div>
      <div class="vx-col w-full md:w-1/4 mb-base">
        <vx-card title="今日注册">
          <span class="font-medium">{{analyticsData.userRegToday || 0}}人</span>
        </vx-card>
      </div>
    </div>

    <div class="vx-row">
      <!-- 未处理的充值订单 -->
      <div class="vx-col w-full md:w-1/2 mb-base">
        <vx-card title="待处理充值订单">
          <vs-table :data="rechargeList">
            <template slot="thead">
              <vs-th width="120">订单ID</vs-th>
              <vs-th>UID</vs-th>
              <vs-th>用户名</vs-th>
              <vs-th>金额</vs-th>
              <vs-th>操作</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :key="indextr" v-for="(tr, indextr) in rechargeList">
                <vs-td :data="rechargeList[indextr].id">
                  <span>#{{rechargeList[indextr].id}}</span>
                </vs-td>
                <vs-td :data="rechargeList[indextr].uid">
                  <span>{{rechargeList[indextr].uid}}</span>
                </vs-td>
                <vs-td :data="rechargeList[indextr].username">
                  <span>{{rechargeList[indextr].username}}</span>
                </vs-td>
                <vs-td :data="rechargeList[indextr].amount">
                  <span>{{rechargeList[indextr].amount}}</span>
                </vs-td>
                <vs-td>
                  <router-link :to="{ name: 'recordRecharge' }">前往</router-link>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vx-card>
      </div>

      <!-- 未处理的提现订单 -->
      <div class="vx-col w-full md:w-1/2 mb-base">
        <vx-card title="待处理提现订单">
          <vs-table :data="cashList">
            <template slot="thead">
              <vs-th width="120">订单ID</vs-th>
              <vs-th>UID</vs-th>
              <vs-th>用户名</vs-th>
              <vs-th>金额</vs-th>
              <vs-th>操作</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :key="indextr" v-for="(tr, indextr) in cashList">
                <vs-td :data="cashList[indextr].id">
                  <span>#{{cashList[indextr].id}}</span>
                </vs-td>
                <vs-td :data="cashList[indextr].uid">
                  <span>{{cashList[indextr].uid}}</span>
                </vs-td>
                <vs-td :data="cashList[indextr].username">
                  <span>{{cashList[indextr].username}}</span>
                </vs-td>
                <vs-td :data="cashList[indextr].count">
                  <span>{{cashList[indextr].count}}</span>
                </vs-td>
                <vs-td>
                  <router-link :to="{ name: 'recordCash' }">前往</router-link>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vx-card>
      </div>
    </div>

  </div>
</template>

<script>

import VueApexCharts from 'vue-apexcharts'
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import analyticsData from './analyticsData.js'

export default {
  data() {
    return {
      version: '',
      analyticsData: analyticsData,
      rechargeList: [],
      cashList: []
    }
  },
  components: {
    VueApexCharts,
    StatisticsCardLine
  },
  mounted () {
    // 版本
    this.$utils.post('other-version', { authKey: localStorage.getItem('authKey') }).then(res => {
      this.version = res
    })
    // 会员数量
    this.$utils.post('general-userCountTrend', { authKey: localStorage.getItem('authKey'), period: 8 }).then(res => {
      let last = 0
      for (const i in res) {
        this.analyticsData.userCountTotalList.series[0].data.push(res[i])
        last = res[i]
      }
      this.analyticsData.userCountTotal = last
      this.analyticsData.userCountTotalList.loaded = true
    })
    // 彩票下注额
    this.$utils.post('general-lotteryBetAmountTrend', { authKey: localStorage.getItem('authKey'), period: 8 }).then(res => {
      let last = 0
      for (const i in res) {
        this.analyticsData.lotteryBetAmountList.series[0].data.push(parseFloat(res[i]).toFixed(4))
        last = parseFloat(res[i]).toFixed(4)
      }
      this.analyticsData.lotteryBetAmountTotal = last
      this.analyticsData.lotteryBetAmountList.loaded = true
    })
    // 充值金额
    this.$utils.post('general-rechargeAmountTrend', { authKey: localStorage.getItem('authKey'), period: 8 }).then(res => {
      let first = -1
      let last = 0
      let count = 0
      for (const i in res) {
        this.analyticsData.rechargeAmountList.series[0].data.push(parseFloat(res[i]).toFixed(4))
        this.analyticsData.rechargeAmountList.chartOptions.colors.push('#e6edf7')
        last = parseFloat(res[i]).toFixed(4)
        if (first === -1) first = res[i]
        count++
      }
      this.analyticsData.rechargeAmountList.chartOptions.colors[count - 1] = '#28C76F'
      this.analyticsData.rechargeAmountTotal = last
      if (first > 0) this.analyticsData.rechargeAmountInc = ((last - first) / first * 100).toFixed(1)
      this.analyticsData.rechargeAmountList.loaded = true
    })
    // 提现金额
    this.$utils.post('general-cashAmountTrend', { authKey: localStorage.getItem('authKey'), period: 8 }).then(res => {
      let first = - 1
      let last = 0
      let count = 0
      for (const i in res) {
        this.analyticsData.cashAmountList.series[0].data.push(parseFloat(res[i]).toFixed(4))
        this.analyticsData.cashAmountList.chartOptions.colors.push('#e6edf7')
        last = parseFloat(res[i]).toFixed(4)
        if (first === -1) first = res[i]
        count++
      }
      this.analyticsData.cashAmountList.chartOptions.colors[count - 1] = '#FF9F43'
      this.analyticsData.cashAmountTotal = last
      if (first > 0) this.analyticsData.cashAmountInc = ((last - first) / first * 100).toFixed(1)
      this.analyticsData.cashAmountList.loaded = true
    })
    // 今日充值额
    this.$utils.post('general-rechargeAmountToday', { authKey: localStorage.getItem('authKey') }).then(res => {
      this.analyticsData.rechargeAmountToday = res
    })
    // 今日提现额
    this.$utils.post('general-cashAmountToday', { authKey: localStorage.getItem('authKey') }).then(res => {
      this.analyticsData.cashAmountToday = res
    })
    // 今日下注额
    this.$utils.post('general-betAmountToday', { authKey: localStorage.getItem('authKey') }).then(res => {
      this.analyticsData.betAmountToday = res
    })
    // 今日活跃会员
    this.$utils.post('general-userActiveToday', { authKey: localStorage.getItem('authKey') }).then(res => {
      this.analyticsData.userActiveToday = res
    })
    // 今日注册
    this.$utils.post('general-userRegToday', { authKey: localStorage.getItem('authKey') }).then(res => {
      this.analyticsData.userRegToday = res
    })
    // 充值记录
    this.$utils.post('record-recharge', { authKey: localStorage.getItem('authKey'), status: 0, method: 'transfer' }).then(res => {
      this.rechargeList = res.list
    })
    // 提现记录
    this.$utils.post('record-cash', { authKey: localStorage.getItem('authKey'), status: 0 }).then(res => {
      this.cashList = res.list
    })
  }
}
</script>

<style lang="scss">
#dashboard-analytics {
  .greet-user{
    position: relative;
    .decore-left{
      position: absolute;
      left:0;
      top: 0;
    }
    .decore-right{
      position: absolute;
      right:0;
      top: 0;
    }
  }

  @media(max-width: 576px) {
    .decore-left, .decore-right{
      width: 140px;
    }
  }
}
</style>
